import React from 'react'
import axios from "axios";
// import { tryGetRefreshToken } from "../actions";
import { SERVER_URL } from "../constants";
// import dayjs from './dayjs-extensions';
import authService from '../utils/authUtils';
import dayjs from 'dayjs';

// let subscribers = []
// let isAlreadyFetchingAccessToken = false
//let accessToken: string | null = localStorage.getItem("accessToken");
//let refreshToken: string | null = localStorage.getItem("refreshToken");
let isRefreshing = false;
let subscribers = [];
export const setTokens = (newAccessToken, newRefreshToken,tokenExpiry) => {
  // console.log("kjadasjkdhaksdhasd",dayjs(),tokenExpiry,dayjs().add(tokenExpiry,"seconds"))
  // accessToken = newAccessToken;
  // refreshToken = newRefreshToken;
  localStorage.setItem("accessToken", newAccessToken);
  localStorage.setItem("refreshToken", newRefreshToken);
  localStorage.setItem("refreshTokenExpiry", dayjs().add(tokenExpiry,"seconds").format());
};
export const getAccessToken = () => localStorage.getItem("accessToken");
export const getRefreshToken = () => localStorage.getItem("refreshToken");
const isTokenExpired = () => {
  // Implement your logic to check if the token is expired
  // This can be done by decoding the JWT and checking its expiration time
  let tokenExpiryString = localStorage.getItem("refreshTokenExpiry")
  if(tokenExpiryString){
    let expiry = dayjs(tokenExpiryString)
    return !(dayjs() < expiry); // 11am < 11:30am => !true => false
  }
  return true; // Placeholder, replace with actual implementation
};
const subscribeTokenRefresh = (callback) => {
  subscribers.push(callback);
};
const onAccessTokenFetched = (newAccessToken) => {
  subscribers.forEach((callback) => callback(newAccessToken));
  subscribers = [];
};
const refreshAccessToken = async () => {
  try {
    if (getRefreshToken()) {
      const response = await api().post("Auth/refresh", { refreshToken: getRefreshToken() });
      if (response.status === 200) {
        const { accessToken: newAccessToken, refreshToken: newRefreshToken, expiresIn: expiry } = response.data;
        setTokens(newAccessToken, newRefreshToken, expiry);
        return newAccessToken;
      } else {
        throw new Error("Failed to refresh token");
      }
    }
    return "";
  } catch (error) {
    throw error;
  }
};

const api = () => {
  const axiosInstance = axios.create({
    baseURL: SERVER_URL,
    withCredentials: false,
  });

  // Inject token into requests
  axiosInstance.interceptors.request.use((req) => {
    
    const token = getAccessToken();
    if (token && req.url !== "Auth/login" && req.url !== "Auth/refresh") {
      req.headers.Authorization = `Bearer ${token}`;
    }
    req.headers['customerId'] = authService.getCustomerId();
    req.headers["Accept"] = "*/*";
    return req;
  });

  // Handle 401 responses and refresh tokens
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      
      const originalRequest = error.config;
      console.log("jaklhsdajkdhalkjdhakd",error)
      if (
        error.response?.status === 401 &&
        !originalRequest._retry &&
        originalRequest.url !== "Auth/login" &&
        originalRequest.url !== "Auth/refresh"
      ) {
        originalRequest._retry = true;

        if (!isRefreshing) {
          isRefreshing = true;

          try {
            const newAccessToken = await refreshAccessToken();
            onAccessTokenFetched(newAccessToken);
            isRefreshing = false;

            originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
            return axiosInstance(originalRequest);
          } catch (err) {
            isRefreshing = false;
            subscribers = [];
            localStorage.clear();
            window.location.href = "/login"; // Redirect to login if refresh fails
            return Promise.reject(err);
          }
        }

        return new Promise((resolve, reject) => {
          subscribeTokenRefresh((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            resolve(axiosInstance(originalRequest));
          });
        });
      }

      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default api;